import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'
import { VueConstructor } from 'vue'
import { mapGetters } from 'vuex'
import { BButton, BDropdownItem, BModal, BvModalEvent } from 'bootstrap-vue'
import { Spinner } from '@kwixeo/interface-vue'

@Component({
  components: {
    BModal,
    Spinner,
  },
  computed: {
    ...mapGetters('user', ['team']),
  }
})
export default class PaymentMethodDelete extends Vue {
  team!: KwixeoFramework.Team

  @Prop({ default: 'button' }) element!: 'button'|'dropdown'|'modal'
  @Prop({ default: null }) label!: TranslateResult|string
  @Prop({ default: null }) btnClass!: KwixeoInterface.CssClass|string|null
  @Prop({ default: null }) size!: string|null
  @Prop({ default: null }) variant!: string|null
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: false }) modal!: boolean

  private loading = false
  private success = false
  private errorMsg: string|null = null
  private modalState = false

  get component (): VueConstructor|null {
    switch (this.element) {
      case 'button':
        return BButton
      case 'dropdown':
        return BDropdownItem
      default:
        return null
    }
  }

  get buttonLabel (): TranslateResult|string {
    return this.label ?? this.$t('interface.delete')
  }

  @Watch('modal', { immediate: true })
  private watchModal (state: boolean): void {
    this.modalState = state
  }

  @Watch('modalState')
  private async watchModalState (): Promise<void> {
    if (this.modalState) {
      this.success = false
      this.errorMsg = null
      this.loading = false
    }
  }

  private async process (event: BvModalEvent): Promise<void> {
    if (this.errorMsg !== null || this.success) {
      return
    }
    event.preventDefault()
    this.loading = true
    this.$kwSubscriptions.axios.delete('/team/subscription/delete-card')
      .then(response => {
        if (response.data.result === 'success') {
          this.success = true
        } else {
          this.errorMsg = 'Une erreur inconnue est survenue'
        }
      })
      .catch(error => {
        this.errorMsg = error.response.data.message ?? 'Une erreur inconnue est survenue'
        throw new Error(error)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private closeModal (): void {
    this.$emit('closed')
  }
}
